import arbic_image from './assets/imgs/icons/SaudiArabia.png';
const lngs = [
  {
    code: 'en', // iso code
    // name: "English",
    name: 'English',
    country_code: 'us',
    img: arbic_image
  },
  {
    code: 'ar', // iso code
    name: 'اللغة العربية',
    country_code: 'sa',
    img: arbic_image
    // dir: "rtl"
  }
];

export default lngs;
